// Age calculator

// Validate if full date is "current location legal age" or over
export const getAgebyDate = (date, legalAge) => {
  const defaultLegalAge = 18
  const getAge = date =>
    Math.floor((new Date() - new Date(date).getTime()) / 3.15576e10)
  const age = getAge(date)
  const ageLimit = legalAge && legalAge !== null ? legalAge : defaultLegalAge

  if (Number.isInteger(age) && age >= ageLimit && age < 123) {
    return [true, 'success']
  } else if (Number.isInteger(age) && age > 123) {
    return [false, 'fakeDate']
  } else {
    return [false, 'globalError']
  }
}

// Validate input fields on change
export const validateDateField = (target) => {
  const name = target.name ? target.name : ''
  const value = target.value ? target.value : ''
  const currentField = target
  let validationValue = ''
  let errorName = ''

  if (name === 'age-gate-DD') {
    validationValue = value >= 1 && value <= 31 // Between day 1 & 31
    errorName = 'dayError'
  } else if (name === 'age-gate-MM') {
    validationValue = value >= 1 && value <= 12 // Between Month 1 & 12
    errorName = 'monthError'
  } else if (name === 'age-gate-YYYY') {
    const currentYear = new Date().getFullYear()
    const yearLength = /^\d{4}$/.test(value)
    if (yearLength === true) {
      validationValue = (value >= 1900) && (value <= currentYear) // Between year 1900 and Today
    } else {
      validationValue = false
    }
    errorName = 'yearError'
  }

  if (validationValue) {
    currentField.classList.remove('error')
    nextField(target, value)
    return [true, errorName]
  } else {
    currentField.classList.add('error')
    return [false, errorName]
  }
}

export const validateFullDate = (dayInput, monthInput, yearInput, type) => {
  let errorName = ''

  // Validate if Day is between 1 & 31
  const dayValue = dayInput.value
  const dayValidation = dayValue >= 1 && dayValue <= 31
  if (!dayValidation && type !== 'silent') {
    dayInput.classList.add('error')
    errorName = 'dayError'
  }

  // Validate if month is between 1 & 12
  const monthValue = monthInput.value
  const monthValidation = monthValue >= 1 && monthValue <= 12
  if (!monthValidation && type !== 'silent') {
    monthInput.classList.add('error')
    errorName = 'monthError'
  }

  // Validate if year is between 1900 and Today
  const yearValue = yearInput.value
  const currentYear = new Date().getFullYear()
  const yearLength = /^\d{4}$/.test(yearValue)
  const yearValidation = (yearValue >= 1900) && yearLength && (yearValue <= currentYear)
  if (!yearValidation && type !== 'silent') {
    yearInput.classList.add('error')
    errorName = 'yearError'
  }

  if (dayValidation && monthValidation && yearValidation) {
    dayInput.classList.remove('error')
    monthInput.classList.remove('error')
    yearInput.classList.remove('error')
    return true
  } else {
    if (type !== 'silent') {
      return [false, errorName]
    }
    return false
  }
}

// Go to next field if value is 2 or more
export const nextField = (target, value) => {
  const currentField = parseInt(target.attributes && target.attributes.index ? target.attributes.index.value : 0)
  const currentForm = target.form ? target.form : null
  const targetIndex = (currentField + 1) % currentForm.length

  if (value.length === 2 || value.length === 4) {
    currentForm[targetIndex].focus()
  } else {
    setTimeout(function () {
      currentForm[targetIndex].focus()
    }, 1000)
  }
}
